import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BackComponent } from '../../../../shared/components/back/back.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-about',
  imports: [BackComponent, TranslateModule],
  templateUrl: './about.component.html',
})
export class AboutComponent {
  private router = inject(Router);

  features = [
    {
      icon: '/icons/one-plane-hover.svg',
      title: 'About.Feature_One_Title',
      body: 'About.Feature_One_Body',
      alt: 'style-plane',
    },
    {
      icon: '/icons/award-hover.svg',
      title: 'About.Feature_Two_Title',
      body: 'About.Feature_Two_Body',
      alt: 'award-star',
    },
    {
      icon: '/icons/secure-hover.svg',
      title: 'About.Feature_Three_Title',
      body: 'About.Feature_Three_Body',
      alt: 'secure',
    },
    {
      icon: '/icons/network-hover.svg',
      title: 'About.Feature_Four_Title',
      body: 'About.Feature_Four_Body',
      alt: 'network',
    },
  ];

  offers = [
    {
      icon: '/icons/flight.svg',
      title: 'About.Offers_One_Title',
      body: 'About.Offers_One_Body',
      alt: 'flight',
    },
    {
      icon: '/icons/booking.svg',
      title: 'About.Offers_Two_Title',
      body: 'About.Offers_Two_Body',
      alt: 'booking',
    },
    {
      icon: '/icons/extra.svg',
      title: 'About.Offers_Three_Title',
      body: 'About.Offers_Three_Body',
      alt: 'extra',
    },
  ];
  heroSectionImages = [
    '/images/hero-sec2.jpg',
    '/images/hero-sec3.jpg',
    '/images/hero-sec1.jpg',
    '/images/hero-sec4.jpg',
  ];

  navigateHome() {
    this.router.navigate(['/']);
  }
}
